import { createAction, props } from '@ngrx/store';
import { FixturesFilters } from './fixtures.reducer';
import { StreamPlayItem } from '@streamamg/stream-play-lib/src/lib/types/stream-play.type';

export const loadMatches = createAction(
  '[Fixtures] Load Matches',
);

export const loadMatchesSuccess = createAction(
  '[Fixtures] Load Matches Success',
  props<{ data: StreamPlayItem[] }>(),
);

export const loadMatchesFailure = createAction(
  '[Fixtures] Load Matches Failure',
  props<any>(),
);

export const filter = createAction(
  '[Fixtures] Filter fixtures',
  props<FixturesFilters>(),
);

export const resetFilters = createAction(
  '[Fixtures] Reset Filters',
);


export const selectMatch = createAction(
  '[Fixtures] Select single match',
  props<{ matchId?: number }>(),
);
